<template>
<section class="premium-section">
<h2 class="section-title">Platform Risk Disclosure and Transparency Statement</h2>

<p>
Participation in blockchain-based ecosystems involves certain risks and limitations. The value of MDR tokens may fluctuate depending on market conditions and adoption levels.
</p>

<p>
Mudra does not guarantee financial returns or token price appreciation. MDR tokens are designed primarily as a reward mechanism within the Mudra creative ecosystem.
</p>

<p>
Blockchain technology also involves potential risks including smart contract vulnerabilities, network congestion, and regulatory changes.
</p>

<p>
Users are encouraged to participate responsibly and understand that digital assets may carry inherent risks.
</p>

<p>
Despite these risks, Mudra remains committed to building a transparent and sustainable ecosystem that supports creators and encourages original storytelling.
</p>

</section>
</template>